import React from "react";
import { Helmet } from "react-helmet";
import LazyImage from "../components/LazyImage";

const Dining = () => {
    const restaurants = [
        {
            src: "/images/dining/el-paso-burgers.jpg",
            alt: "El Paso Spur",
            title: "El Paso Spur – Vanderbijlpark",
            description: "Located next to Baltimore Mansions, this Spur serves as the breakfast destination for many of our guests. A warm, family-friendly atmosphere with the quality meals you know and love.",
            note: "Breakfast option for Baltimore guests",
            url: "https://www.facebook.com/ElPasoSpur/"  // :contentReference[oaicite:1]{index=1}
        },

        {
            src: "/images/dining/john-dorys-vaal.jpg",
            alt: "John Dory's – Vaal Mall",
            title: "John Dory's – Vaal Mall",
            description: "Enjoy fresh seafood, sushi, and grilled meals in the heart of Vaal Mall. A favorite stop for families and visitors staying in Vanderbijlpark.",
            url: "https://www.johndorys.com/za/restaurants/gauteng/john-dorys-vaal-mall"  // :contentReference[oaicite:3]{index=3}
        },
        {
            src: "/images/dining/panarottis-pizza.jpg",
            alt: "Panarottis – Vaal Mall",
            title: "Panarottis – Vaal Mall",
            description: "Italian-inspired dining with pizza, pasta, and family-friendly hospitality. Conveniently located inside Vaal Mall.",
            url: "https://www.panarottis.com/za/restaurants/gauteng/panarottis-vaal-mall"  // :contentReference[oaicite:4]{index=4}
        },
        {
            src: "/images/dining/amigo-spur.png",
            alt: "Amigo Spur",
            title: "Amigo Spur – Vanderbijlpark",
            description: "A vibrant and welcoming Spur branch offering all the classics: steaks, ribs, burgers, and more. Perfect for groups and casual dining.",
            url: "https://www.facebook.com/AmigoSpur/"  // :contentReference[oaicite:5]{index=5}
        },

        {
            src: "/images/dining/silverado-spur.webp",
            alt: "Silverado Spur",
            title: "Silverado Spur – Vanderbijlpark",
            description: "A well‑known local favorite with a relaxed atmosphere and reliable Spur classics — perfect for guests and residents alike.",
            url: "https://www.facebook.com/SilveradoSpur/"  // :contentReference[oaicite:7]{index=7}
        },
        {
            src: "/images/dining/panarottis-riverstone.jpg",
            alt: "Panarottis",
            title: "Panarottis – Riverstone Mall",
            description: "Enjoy classic Panarottis pizza and pasta at Riverstone Mall — family-friendly and perfect for group dining.",
            url: "https://www.facebook.com/PanarottisMeyerton"  // :contentReference[oaicite:7]{index=7}
        },       
    ];

    return (
        <div className="bg-[#F2F1F0] text-[#144E73] font-sans min-h-screen pt-20 pb-24 px-6">
            <Helmet>
                {/* existing head tags */}
            </Helmet>

            <div className="max-w-6xl mx-auto">
                <h1 className="text-4xl md:text-5xl font-bold text-center text-primarymb-8">
                    Dining with the Benecke Group
                </h1>
                <p className="text-center max-w-3xl mx-auto text-lg leading-relaxed mb-12">
                    No need to cook — we’ve already saved you a seat. From pasta to plant-based, there’s something here for everyone.
                </p>

                <section aria-label="List of partner restaurants" className="grid md:grid-cols-2 gap-10">
                    {restaurants.map((r, idx) => (
                        <a
                            key={idx}
                            href={r.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-white rounded-xl shadow border border-[#1D4E80] overflow-hidden block focus:outline-none focus:ring-2 focus:ring-[#FEB339]"
                        >
                            <LazyImage
                                src={r.src}
                                alt={r.alt}
                                className="w-full h-56 object-cover border-b border-[#1D4E80]"
                            />
                            <div className="p-6">
                                <h2 className="text-2xl font-semibold text-primarymb-2">{r.title}</h2>
                                <p className="text-sm leading-relaxed mb-2">{r.description}</p>
                                {r.note && <p className="text-xs text-[#666] italic">{r.note}</p>}
                            </div>
                        </a>
                    ))}
                </section>


            </div>
        </div>
    );
};

export default Dining;
